import { render, staticRenderFns } from "./PackingRuleForm.vue?vue&type=template&id=1346ee32&scoped=true"
import script from "./PackingRuleForm.vue?vue&type=script&lang=js"
export * from "./PackingRuleForm.vue?vue&type=script&lang=js"
import style0 from "./PackingRuleForm.vue?vue&type=style&index=0&id=1346ee32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1346ee32",
  null
  
)

export default component.exports